document.addEventListener('DOMContentLoaded', () => {
  const revealItems = document.querySelectorAll('.pc3-reveal');
  if (!revealItems.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revealItems.forEach((el) => el.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  revealItems.forEach((el) => io.observe(el));
});

// Keep the product restock request form aligned with the selected variant.
document.addEventListener('shopify:product:select', async (event) => {
  const scope = event.target?.closest?.('.shopify-section, product-component, main');
  const formWrap = scope?.querySelector?.('[data-pc3-restock-form]');
  if (!formWrap || !event.promise) return;

  try {
    const result = await event.promise;
    const variant = result?.detail?.resource;
    const isAvailable = Boolean(variant && variant.available);
    const variantId = variant?.id ? String(variant.id) : '';
    const variantTitle = variant?.title || '';
    const productTitle = formWrap.dataset.productTitle || '';
    const productHandle = formWrap.dataset.productHandle || '';
    const productId = formWrap.dataset.productId || '';
    const baseProductUrl = formWrap.dataset.productUrl || window.location.href.split('?')[0];
    const productUrl = variantId ? `${baseProductUrl}?variant=${variantId}` : baseProductUrl;
    const message = [
      'Customer requested a restock notification.',
      `Product: ${productTitle}.`,
      `Product URL: ${productUrl}.`,
      `Product handle: ${productHandle}.`,
      `Product ID: ${productId}.`,
      variantTitle ? `Variant: ${variantTitle}.` : '',
      variantId ? `Variant ID: ${variantId}.` : ''
    ].filter(Boolean).join(' ');

    formWrap.hidden = isAvailable;

    const productUrlInput = formWrap.querySelector('[data-pc3-restock-product-url]');
    const variantTitleInput = formWrap.querySelector('[data-pc3-restock-variant-title]');
    const variantIdInput = formWrap.querySelector('[data-pc3-restock-variant-id]');
    const messageInput = formWrap.querySelector('[data-pc3-restock-message]');

    if (productUrlInput) productUrlInput.value = productUrl;
    if (variantTitleInput) variantTitleInput.value = variantTitle;
    if (variantIdInput) variantIdInput.value = variantId;
    if (messageInput) messageInput.value = message;
  } catch (error) {
    console.warn('[PirateCards] Unable to update restock form for selected variant.', error);
  }
});

// PirateCards v5: make fallback collection category labels stable and accessible.
document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  const categoryFromPath = window.location.pathname.match(/^\/collections\/(singles|slabs|sealed)\/?$/)?.[1] || '';
  const rawCategory = (params.get('pc_category') || categoryFromPath).toLowerCase();
  const labels = {
    singles: 'Singles',
    slabs: 'Slabs',
    sealed: 'Sealed'
  };
  const label = labels[rawCategory];
  if (!label) return;

  document.documentElement.classList.add('pc3-category-page', `pc3-cat-${rawCategory}`);
  document.documentElement.setAttribute('data-pc-category', rawCategory);

  if (window.location.pathname.includes('/collections/all')) {
    const headings = Array.from(document.querySelectorAll('main h1'));
    headings.forEach((heading) => {
      const text = heading.textContent.trim().toLowerCase();
      if (['products', 'collections', 'singles', 'slabs', 'sealed'].includes(text)) {
        heading.textContent = label;
        heading.setAttribute('data-pc-category-title', label);
      }
    });
  }

  document.querySelectorAll('[data-pc-category-link]').forEach((link) => {
    link.classList.toggle('is-active', link.getAttribute('data-pc-category-link') === rawCategory);
  });

  if (document.title) {
    document.title = document.title.replace(/^(Products|Collections|Singles|Slabs|Sealed)/i, label);
  }
});
